export var branchNumber = '9999';
export var accountNumber = '99999-9';
export var operatorCode = '999999999';
export var creditCard = '9999 9999 9999 9999';
export var cpf = '999.999.999-99';
export var maskers = {
  branchNumber: branchNumber,
  accountNumber: accountNumber,
  operatorCode: operatorCode,
  creditCard: creditCard,
  cpf: cpf
};